import { Typography } from "@mui/material";
import { StyleDict, TextStyle } from "../util/TextStyles";
import { ReactNode } from "react";

export function StyledText({ children, textStyle }: { children: ReactNode; textStyle?: TextStyle }) {
  return <Typography style={textStyle ? StyleDict[textStyle] : undefined}>{children}</Typography>;
}
